import { CONSOLIDATED_FEED_DEFAULT_CHECKOUT_MOV_CENTS } from "../../core/components/product-list/product-list.constants";
import { isConsolidatedFeedOrder } from "./is-consolidated-feed-order";

type CartLineLike = {
    linePriceWithTax: number;
    discountedLinePriceWithTax?: number | null;
    customFields?: { isConsolidatedFeedLine?: boolean | null } | null;
};

type CartOrderLike = {
    customFields?: { isConsolidatedFeed?: boolean | null } | null;
    lines?: CartLineLike[] | null;
};

export function resolveConsolidatedFeedCheckoutMovCents(
    customerMovCents?: number | null,
): number {
    return customerMovCents != null && customerMovCents > 0
        ? customerMovCents
        : CONSOLIDATED_FEED_DEFAULT_CHECKOUT_MOV_CENTS;
}

export function isConsolidatedFeedLine(
    line: CartLineLike | null | undefined,
): boolean {
    return line?.customFields?.isConsolidatedFeedLine === true;
}

export function getConsolidatedFeedLines(
    lines: CartLineLike[] | null | undefined,
): CartLineLike[] {
    if (!lines?.length) {
        return [];
    }
    return lines.filter(isConsolidatedFeedLine);
}

export function cartHasConsolidatedFeedLines(
    lines: CartLineLike[] | null | undefined,
): boolean {
    return getConsolidatedFeedLines(lines).length > 0;
}

export function shouldOrderBeConsolidatedFeed(
    lines: CartLineLike[] | null | undefined,
): boolean {
    if (!lines?.length) {
        return false;
    }
    return lines.every(isConsolidatedFeedLine);
}

export function isConsolidatedFeedCart(order: unknown): boolean {
    const cart = order as CartOrderLike | null | undefined;
    if (cartHasConsolidatedFeedLines(cart?.lines)) {
        return true;
    }
    return isConsolidatedFeedOrder(cart);
}

export function getConsolidatedFeedCartTotal(
    lines: CartLineLike[] | null | undefined,
): number {
    const consolidatedLines = getConsolidatedFeedLines(lines);
    if (!consolidatedLines.length) {
        return 0;
    }
    return consolidatedLines.reduce(
        (sum, line) =>
            sum +
            (line.discountedLinePriceWithTax ?? line.linePriceWithTax ?? 0),
        0,
    );
}

export function getConsolidatedFeedMovRemaining(
    lines: CartLineLike[] | null | undefined,
    customerMovCents?: number | null,
): number {
    return Math.max(
        0,
        resolveConsolidatedFeedCheckoutMovCents(customerMovCents) -
            getConsolidatedFeedCartTotal(lines),
    );
}

export function isConsolidatedFeedMovMet(
    lines: CartLineLike[] | null | undefined,
    customerMovCents?: number | null,
): boolean {
    if (!cartHasConsolidatedFeedLines(lines)) {
        return true;
    }
    return getConsolidatedFeedMovRemaining(lines, customerMovCents) <= 0;
}
